// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"610":"2a15cd60","763":"6ee25541","894":"6ee25541"}[chunkId] + ".chunk.css";
};